import { render, staticRenderFns } from "./pay-slip3.vue?vue&type=template&id=769f58a3&"
import script from "./pay-slip3.vue?vue&type=script&lang=js&"
export * from "./pay-slip3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports